import { Routes } from "@angular/router";
import { SigninComponent, SignoutComponent, UnauthorizedComponent } from "@palliativ-core/pages";
import { authGuard } from "@palliativ-core/auth/auth.guard";
import { ManageMessagesComponent } from "./pages/manageMessages/manage-messages.component";


export const routes: Routes = [
    { path: "signin", component: SigninComponent },
    { path: "signout", component: SignoutComponent },
    { path: "unauthorized", component: UnauthorizedComponent },
    { path: "manageMessages", component: ManageMessagesComponent, canActivate: [authGuard] },
    {
        path: "",
        loadChildren: () => import("./pages/home/home.module").then(m => m.HomeModule),
        canActivate: [authGuard],
    }
];

